import BreadcrumbListSD from 'components/common/SEO/BreadcrumbListSD'
import FacebookOGMetas from 'components/common/SEO/FacebookOGMetas'
import OrganisationSD from 'components/common/SEO/OrganisationSD'
import TwitterMarups from 'components/common/SEO/TwitterMarups'
import WebPageSD from 'components/common/SEO/WebPageSD'
import WebSiteSD from 'components/common/SEO/WebSiteSD'
import { CategoryNeutralPath, LearningPathNeutralPath, CourseNeutralPath } from 'navigation/Routes'
import { Helmet } from 'react-helmet'
import Text from './text.json'

const breadcrumbList = (slug, title, category) => [
  {
    link: window.location.origin,
    name: 'Accueil'
  },
  {
    link: `${window.location.origin}${CategoryNeutralPath}${LearningPathNeutralPath}`,
    name: "parcours d'apprentissage"
  },
  {
    link: `${window.location.origin}${LearningPathNeutralPath}/${slug}`,
    name: title
  }
]

export default ({ title, subtitle, categories, duration, image, slug, metaTitle, metaDescription, Courses }) => {
  const categoryList = categories.length ? categories.map(category => category.Name).join(' > ') : ''
  const description = `${subtitle} ${categoryList} ${title} ${categoryList} ${duration}`
  const link = `${window.location.origin}${LearningPathNeutralPath}/${slug}`
  const selectedTitle = metaTitle || `${Text.prefixTitle} ${title} ${Text.sufixTitle}`
  const selectedDescription = metaDescription || description
  return (
    <>
      <Helmet>
        <title>{selectedTitle}</title>
        <meta name='description' content={selectedDescription} />
        <link rel='canonical' href={link} />

        <script type='application/ld+json'>
          {
        `
        {
          "@context": "https://schema.org",
          "@type": "EducationalOccupationalProgram",
          "name": "${selectedTitle}",
          "description": "${selectedDescription}",
          url: "${link}",
          "provider": { 
              "@type": "Organization",
              "name": "Alphorm", 
              "url": "https://www.alphorm.com", 
              "logo": "https://static.alphorm.com/logos/logosanslecture.png" 
          },
          "hasCourse": [  
          ${Courses.map((course) => `
            {
              "@type": "Course",
              "name": "${course.Title}",
              "description": "${course?.Description?.trim() ? course.Description : course.Title}",
              "url": "${window.location.origin}${CourseNeutralPath}/${course.Slug}",
              "datePublished": "${course.PublicationDate}",
              "provider": {
                "@type": "Organization",
                "name": "Alphorm", 
                "url": "https://www.alphorm.com", 
                "logo": "https://static.alphorm.com/logos/logosanslecture.png" 
              }
            }
            `)}
          ]
        }
        `
      }
        </script>
      </Helmet>
      <FacebookOGMetas
        link={link}
        title={title}
        description={description}
        image={image}
      />
      <TwitterMarups
        link={link}
        title={title}
        description={description}
        image={image}
      />
      <OrganisationSD />
      <WebSiteSD />
      <WebPageSD
        title={title}
        description={description}
      />
      <BreadcrumbListSD items={breadcrumbList(slug, title, categoryList)} />
    </>
  )
}
